var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExclam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M39.7193 17.077C44.3835 9.32929 55.6164 9.32927 60.2807 17.077L91.8772 69.5607C96.6922 77.5587 90.932 87.75 81.5965 87.75H18.4035C9.06803 87.75 3.30783 77.5587 8.1228 69.5608L39.7193 17.077Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2684 42.4897C47.1236 40.6073 48.612 39 50.5 39V39C52.388 39 53.8764 40.6073 53.7316 42.4897L52.115 63.5044C52.0501 64.3483 51.3464 65 50.5 65V65C49.6536 65 48.9499 64.3483 48.885 63.5044L47.2684 42.4897Z",
    fill: "#333D6C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 69.5,
    r: 2.5,
    fill: "#333D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclam);
export default __webpack_public_path__ + "static/media/icon-exclam.5c8f61554f6e1c9090c90b0706d585bb.svg";
export { ForwardRef as ReactComponent };